import React, { Fragment } from "react";
import './code.scss';

const Code = ({children, showCode}) => {
    return showCode && (
    <Fragment>
        <div className={`${showCode ? "appear": "disappear"} show-the-code` }>        
            {children}
        </div>
    </Fragment>    
    )
}

export default Code;